import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';

import SweetAlert from 'react-bootstrap-sweetalert';
import { Card, CardBody, CardTitle, Col, Row, Badge } from 'reactstrap';
import { Th, Thead, Tr } from 'react-super-responsive-table';

import { getPlcSafetyEvents, deletePlcSafetyEvent, getPlcSafetyZones } from '../../store/actions';
import './PlcSafetyEventList.scss';

class PlcSafetyEventList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      showConfirm: false,
      eventToDelete: null,
      popup: false,
      pop_msg: '',
      alertType: '',
    };
  }

  componentDidMount() {
    this.props.getPlcSafetyZones(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (this.props.loadingDeletePlcSafetyEvent === false && prevProps.loadingDeletePlcSafetyEvent === true) {
      this.props.getPlcSafetyEvents(this.state.user);
      if (this.props.deletePlcSafetyEventError) {
        this.setState({
          popup: true,
          pop_msg: this.props.deletePlcSafetyEventError.message || 'Error al eliminar el evento',
          alertType: 'error',
        });
      }
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
  }

  confirmDelete(event) {
    this.setState({ showConfirm: true, eventToDelete: event });
  }

  doDelete() {
    const { user, eventToDelete } = this.state;
    this.props.deletePlcSafetyEvent({ id: eventToDelete.id, token: user.token });
    this.setState({ showConfirm: false });
  }

  render() {
    const { eventList } = this.props;
    const zoneNameByCode = {};
    const invokableByCode = {};
    (this.props.zones || []).forEach((z) => {
      zoneNameByCode[z.zone_code] = z.zone_name;
      invokableByCode[z.zone_code] = Number(z.api_invokable) === 1;
    });
    // Las invocables en RCS primero — son las que realmente ejecutan la acción, más relevantes
    // de un vistazo que las de solo bookkeeping/LED.
    const sortZones = (zones) =>
      [...(zones || [])].sort((a, b) => (invokableByCode[b.zone_code] ? 1 : 0) - (invokableByCode[a.zone_code] ? 1 : 0));
    return (
      <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="mb-4">{this.props.t('Eventos PLC Safety')}</CardTitle>
              <div className="table-responsive">
                <table className="table table-centered table-nowrap mb-0">
                  <Thead>
                    <Tr>
                      <Th>{this.props.t('Nombre')}</Th>
                      <Th>{this.props.t('Indicador')}</Th>
                      <Th>{this.props.t('Zonas / Acción')}</Th>
                      <Th>{this.props.t('Estado')}</Th>
                      <Th>{this.props.t('Actions')}</Th>
                    </Tr>
                  </Thead>
                  <tbody>
                    {eventList.map((e) => (
                      <tr key={e.id}>
                        <td>
                          <span>{e.name}</span>
                        </td>
                        <td>
                          <span>{e.led_scope === 'NONE' ? '—' : `${e.led_scope} / ${e.led_state}`}</span>
                        </td>
                        <td className="plc-safety-event-zones-cell">
                          {(e.zones || []).length ? (
                            <div className="d-flex flex-wrap">
                              {sortZones(e.zones).map((z) => (
                                <Badge key={z.zone_code} color={z.action ? 'info' : 'secondary'} className="font-size-11 mr-1 mb-1" pill>
                                  {(zoneNameByCode[z.zone_code] || z.zone_code) + (z.action ? ` (${z.action})` : '')}
                                </Badge>
                              ))}
                            </div>
                          ) : (
                            '—'
                          )}
                        </td>
                        <td>
                          {e.has_active_causes ? (
                            <Badge color="danger" pill>
                              {this.props.t('Causa activa')}
                            </Badge>
                          ) : (
                            <Badge color="success" pill>
                              {this.props.t('Libre')}
                            </Badge>
                          )}
                        </td>
                        <td>
                          <button
                            className="btn btn-primary waves-effect waves-light buttonStatus txtField"
                            title="Detalle"
                            onClick={() =>
                              this.props.history.push({
                                pathname: `/plcSafetyEventDetail/${e.id}`,
                                state: e,
                              })
                            }
                          >
                            <i className="mdi mdi-pencil font-size-14 align-middle"></i>
                          </button>
                          <button
                            className="btn btn-danger waves-effect waves-light buttonStatus txtField"
                            title="Eliminar"
                            disabled={e.has_active_causes}
                            onClick={() => this.confirmDelete(e)}
                          >
                            <i className="far fa-trash-alt font-size-14 align-middle"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
        {this.state.showConfirm ? (
          <SweetAlert
            showCancel
            title="¿Estás seguro?"
            cancelBtnBsStyle="danger"
            confirmBtnBsStyle="success"
            confirmBtnText={this.props.t('ok')}
            cancelBtnText={this.props.t('Cancel')}
            onConfirm={() => this.doDelete()}
            onCancel={() => this.setState({ showConfirm: false })}
          >
            {this.props.t('Solo se puede borrar un evento sin causas activas y sin triggers asociados')}
          </SweetAlert>
        ) : null}
        {this.state.popup ? (
          <SweetAlert
            type={this.state.alertType === 'correct' ? 'success' : 'error'}
            confirmBtnBsStyle={this.state.alertType === 'correct' ? 'success' : 'danger'}
            title={this.state.pop_msg}
            confirmBtnText={this.props.t('ok')}
            onConfirm={() => this.confirmPopup()}
          ></SweetAlert>
        ) : null}
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  const { loadingDeletePlcSafetyEvent, deletePlcSafetyEventError } = state.deletePlcSafetyEvent;
  const { zones } = state.getPlcSafetyZones;
  return { loadingDeletePlcSafetyEvent, deletePlcSafetyEventError, zones };
};

export default withRouter(
  connect(mapStateToProps, { getPlcSafetyEvents, deletePlcSafetyEvent, getPlcSafetyZones })(
    withNamespaces()(PlcSafetyEventList),
  ),
);
